import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css'
import domReady from '@wordpress/dom-ready';

domReady(function () {
	const lightboxVideo = GLightbox({
		selector: '.video-lightbox',
		autoplayVideos: true,
		onOpen: () => {
			console.log('Lightbox opened')
		},
	});

});
